import React from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import HomeLayout from "../DesignLayout/HomeLayout";
import Login from "../Components/Login/Login";
import Dashboard from "../Components/Dashboard/Dashboard";
import Report from "../Components/Report/Report";
import Projects from "../Components/Projects/Projects";
import Tasks from "../Components/Tasks/Tasks";
import Bugs from "../Components/Bugs/Bugs";
import User from "../Components/User/User";
import ForgotPassword from "../Components/ForgetPassword/ForgetPassword";
import UserReport from '../Components/UserReport/UserReport';
import ProtectedRoute from "../ProtectedRoute/ProtectedRoute";
import UserDetails from '../Components/IssuePage/UserDetail/UserDetails';
import ProjectReport from "../Components/ProjectReport/ProjectReport";
import TaskReport from "../Components/TaskReport/TaskReport";
import BugReport from "../Components/BugReport/BugReport";
import TaskIssuePage from "../Components/IssuePage/TaskDetails/TaskIssuePage";
import BugDetails from '../Components/IssuePage/BugDetails/BugDetails';
import ProjectDetails from '../Components/IssuePage/ProjectDetails/ProjectDetails';
import ResetPassword from '../Components/ForgetPassword/ResetPassword';
function MainRouting() {
  return (
    <div className="routing">
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path='/reset-password' element={<ResetPassword/>} />
        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <HomeLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="reports" element={<Report />}>
            {/* Nested Routes for Report */}
            <Route path="projectreport" element={<Projects />} />
            <Route path="taskreport" element={<TaskReport />} />
            <Route path="bugreport" element={<BugReport />} />
            <Route path="userReport" element={<UserReport />} />
            
          </Route>
          <Route path="projects" element={<Projects />} />
          <Route path="tasks" element={<Tasks />} />
          <Route path="bugs" element={<Bugs />} />
          <Route path="user" element={<User />} />
          <Route path="taskdetails" element={<TaskIssuePage />} />
          <Route path='bugdetails' element={<BugDetails/>} />
          <Route path='projectdetails' element={<ProjectDetails/>} />
          <Route path='userdetails' element={<UserDetails/>}/>
        </Route>
      </Routes>
    </Router>
  </div>
  )
}

export default MainRouting
